import styled from 'styled-components';

import {
	SYS_BREAKPOINT_2_XL,
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_SM,
	SYS_BREAKPOINT_XL,
	SYS_PAGE_MARGIN_2_XL,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_PAGE_MARGIN_XL,
} from '@oneaudi/unified-web-common';

export const MainStyle = styled.main`
	display: flex;
	flex-direction: column;
	.gallery-wrapper {
		display: flex;
		flex-direction: column;
		min-width: 0;
		width: 100%;
		max-width: 1248px;
		height: max-content;
		align-self: center;
		padding: 0;
	}
`;

export const PaddingContainer = styled.div<{ $noPadding?: boolean }>`
	display: flex;
	flex-direction: column;
	padding: 0 ${SYS_PAGE_MARGIN_SM};

	@media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
		padding-left: ${SYS_PAGE_MARGIN_SM};
		padding-right: ${SYS_PAGE_MARGIN_SM};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
		padding-left: ${SYS_PAGE_MARGIN_MD};
		padding-right: ${SYS_PAGE_MARGIN_MD};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
		padding-left: ${SYS_PAGE_MARGIN_LG};
		padding-right: ${SYS_PAGE_MARGIN_LG};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
		padding-left: ${SYS_PAGE_MARGIN_XL};
		padding-right: ${SYS_PAGE_MARGIN_XL};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
		padding-left: ${SYS_PAGE_MARGIN_2_XL};
		padding-right: ${SYS_PAGE_MARGIN_2_XL};
	}

	padding-left: ${(props) => (props.$noPadding ? '0 !important' : 'inherit')};
	padding-right: ${(props) => (props.$noPadding ? '0 !important' : 'inherit')};
`;
